import React, { createContext, useContext, useReducer } from "react";
import { wishListReducer } from "../reducers/wishListReducer";
import { initialSummary } from "../Data/sharedSafari";

//Create context
export const WishListContext = createContext();

//Initial state
const initialState = {
  //Wishlist ages
  packges: [],
  summaryPack: initialSummary,
  pageIndexPack: 1,
  loadingPack: true,
  errorPack: '',

  //Wishlist Shared Safari
  sharedSafaries: [],
  summarySafari: initialSummary,
  pageIndexSafari: 1,
  loadingSafari: true,
  errorSafari: '',

  //set active tab
  activeTab: 'package',

};

//Provider
const WishListProvider = ({ children }) => {
  const [wishListState, wishListDispatch] = useReducer(wishListReducer, initialState);


  return (
    <WishListContext.Provider
      value={{
        ...wishListState,
        wishListDispatch,
      }}
    >
      {children}
    </WishListContext.Provider>
  );
};

//hook
export const useWishListContext = () => useContext(WishListContext);

export default WishListProvider;
